const {
  RolesRepositoryNotWorkingException
} = require("../../../controller/talentbait/roles/domain");

const ROLES_COLLECTION = "roles";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  return {
    id: snap.id,
    ...snap.data()
  };
};

function RolesMixin() {
  return {
    /**
     * Gets all roles from database
     * @returns The roles data or empty array
     */
    async getRoles() {
      try {
        const snapshot = await this.collection(ROLES_COLLECTION).get();
        return populateSnapshots(snapshot);
      } catch (error) {
        throw new RolesRepositoryNotWorkingException(error.message);
      }
    }
  };
}

module.exports = RolesMixin;
